module.exports = __webpack_public_path__ + "static/media/style transger.34133d8a.JPG";